<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.0002 29.3346H8.00016C7.29292 29.3346 6.61464 29.0537 6.11454 28.5536C5.61445 28.0535 5.3335 27.3752 5.3335 26.668V5.33465C5.3335 4.6274 5.61445 3.94912 6.11454 3.44903C6.61464 2.94893 7.29292 2.66798 8.00016 2.66798H18.6668C19.0894 2.66694 19.5079 2.74959 19.8983 2.91116C20.2887 3.07272 20.6433 3.31001 20.9415 3.60931L25.7255 8.39331C26.0248 8.69154 26.2621 9.04609 26.4237 9.4365C26.5852 9.82692 26.6679 10.2455 26.6668 10.668V18.668" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M18.6665 2.66797V9.33464C18.6665 9.68826 18.807 10.0274 19.057 10.2774C19.3071 10.5275 19.6462 10.668 19.9998 10.668H26.6665" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19 26.6667L21.6667 29.3333L27 24" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#0A77FF',
    },
  },
};
</script>
